<template>
  <v-card max-width="560">
    <vue-element-loading :active="isLoading" :is-full-screen="true" />
    <v-card-title class="text-h6">
      {{ $t('change_password') }}
    </v-card-title>
    <v-card-subtitle>
      {{ $t('change_password_help') }}
    </v-card-subtitle>
    <v-card-text>
      <v-form ref="form">
        <v-text-field
          v-model="newPassword"
          :rules="[rules.required, rules.min]"
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
          :label="$t('new_password')"
          :hint="$t('password_hint')"
          persistent-hint
          outlined
          dense
          class="mb-4"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
        <v-text-field
          v-model="confirmPassword"
          :rules="[rules.required, rules.match]"
          :type="showConfirm ? 'text' : 'password'"
          :append-icon="showConfirm ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
          :label="$t('confirm_new_password')"
          outlined
          dense
          @click:append="showConfirm = !showConfirm"
        ></v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions class="px-4 pb-4">
      <v-btn color="primary" depressed :disabled="isLoading" @click="save">
        {{ $t('save_changes') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { adminProfileStore } from '@/utils/helpers'

export default {
  components: { VueElementLoading },
  data() {
    return {
      isLoading: false,
      newPassword: '',
      confirmPassword: '',
      showPassword: false,
      showConfirm: false,
    }
  },
  mounted() {
    if (!adminProfileStore.id && !localStorage.getItem('userId')) {
      axios.get('/users/admin', { params: { user_id: 1 } }).then((response) => {
        adminProfileStore.id = response.data.id
        localStorage.setItem('userId', response.data.id)
      }).catch(() => {})
    }
  },
  computed: {
    rules() {
      return {
        required: (v) => !!v || this.$t('required'),
        min: (v) => (!v || v.length >= 8) || this.$t('min_8_characters'),
        match: (v) => v === this.newPassword || this.$t('passwords_dont_match'),
      }
    },
    userId() {
      return adminProfileStore.id || localStorage.getItem('userId')
    },
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return
      if (!this.userId) {
        this.$swal(this.$t('error_title'), this.$t('error_updating_user'), 'error')
        return
      }
      this.isLoading = true
      axios
        .post('/users/update-password', {
          user_id: this.userId,
          password: this.newPassword,
        })
        .then(() => {
          this.isLoading = false
          this.newPassword = ''
          this.confirmPassword = ''
          this.$refs.form.resetValidation()
          this.$notify({
            title: this.$t('success_title'),
            text: this.$t('password_updated'),
            type: 'success',
          })
        })
        .catch((error) => {
          this.isLoading = false
          const message =
            (error.response && error.response.data && error.response.data.message) ||
            this.$t('error_updating_user')
          this.$swal(this.$t('error_title'), message, 'error')
        })
    },
  },
}
</script>
